export default __webpack_public_path__ + "static/media/apple.335dd94f.svg";